import _ from "lodash";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Avatar from "react-avatar";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Collapse } from "reactstrap";
import { withNamespaces } from "react-i18next";
import { Link } from "react-router-dom";
import { setZooTier, setUserRole, setZooTimezone } from "../../store/actions/zoo.actions";
import { UserDatabaseConnector } from "../../dataconnector/usersDatabaseConnector";
import { getZooList } from "../../tools/conf";

const uConnect = new UserDatabaseConnector();

class SidebarUserBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserBlock: true,
      dropDown: false,
    };
  }

  toggleDropDown = () => {
    this.setState({ dropDown: !this.state.dropDown });
  };

  handleZooChange = async (zoo) => {
    let userData = this.state;
    let showUserBlock = this.state.showUserBlock;

    delete userData.showUserBlock;
    delete userData.dropDown;
    delete userData.zooList;

    userData.zooId = zoo.value;
    userData.userZoo = zoo;

    let res = await uConnect._updateTempUserData(userData);

    if (res.success) {
      let filteredZooList = [];
      getZooList().map((zoo) => {
        if (zoo.value !== res.data.zooId) {
          filteredZooList.push(zoo);
        }
      });
      
      // Récupérer les données du nouveau zoo pour obtenir le tier
      // Pour un changement via SidebarUserBlock, on doit chercher le tier dans la liste des zoos
      const zooList = getZooList();
      const selectedZoo = zooList.find(z => z.value === zoo.value);
      
      let zooTier = 'essential'; // Par défaut
      let zooTimezone = null;

      // Toujours récupérer les données du zoo pour obtenir le timezone
      const zooData = await uConnect._getZooData();
      if (zooData && zooData.success && zooData.data) {
        zooTier = zooData.data.followUpLevel || 'essential';
        zooTimezone = zooData.data.timezone || null;
      } else if (selectedZoo && selectedZoo.tier) {
        zooTier = selectedZoo.tier;
      }

      // Mapper les valeurs legacy
      if (zooTier === 'basic') {
        zooTier = 'essential';
      }

      // Stocker le tier temporaire
      localStorage.setItem('tempZooTier', zooTier);
      console.log('SidebarUserBlock: Zoo changed, updating tier to', zooTier, 'and timezone to', zooTimezone);

      // Mettre à jour le tier et le timezone dans Redux
      this.props.setZooTier(zooTier);
      this.props.setZooTimezone(zooTimezone);
      
      // Garder le rôle de l'utilisateur
      const userRight = await uConnect._getUserRight();
      const userRole = userRight?.data?.userRight || 'user';
      this.props.setUserRole(userRole);

      this.setState({
        ...res.data,
        showUserBlock: showUserBlock,
        zooList: filteredZooList,
        dropDown: false,
      });
      
      // Le menu se mettra à jour automatiquement grâce à Redux
    }
  };

  componentDidMount = async () => {
    try {
      let user = await uConnect._getUserData();
      let userRight = await uConnect._getUserRight();
      
      // Ne pas récupérer zooData ici si on l'a déjà dans Redux
      // Le Sidebar le fait déjà et met à jour le store
      
      let zooList = getZooList();
      let filteredZooList = [];
      zooList.map((zoo) => {
        if (zoo.value !== user.data.zooId) {
          filteredZooList.push(zoo);
        }
      });
      
      this.setState({
        ...user.data,
        // Ces valeurs viendront de Redux via les props
        // userRole: userRight?.data?.userRight || 'user',
        // zooTier: zooData?.data?.followUpLevel || 'essential',
        zooList: filteredZooList,
      });
    } catch (error) {
      console.log(error);
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.showUserBlock !== prevProps.showUserBlock) {
      this.setState({ showUserBlock: this.props.showUserBlock });
    }
    // Force re-render when theme changes is handled automatically by React
  }

  render() {
    // Determine if current theme is dark
    const isDarkTheme = this.props.theme &&
      (this.props.theme.path === 'themes/theme-e.css' ||
       this.props.theme.path === 'themes/theme-f.css' ||
       this.props.theme.path === 'themes/theme-g.css' ||
       this.props.theme.path === 'themes/theme-h.css');

    const userBlockClass = isDarkTheme ? "item user-block user-block-dark" : "item user-block";

    return (
      <Collapse id="user-block" isOpen={this.state.showUserBlock}>
        <div>
          <div className={userBlockClass}>
            {/* User picture */}
            <div className="user-block-picture">
              <div className="user-block-status">
                {_.has(this.state.userProfilePicture, "url") ? (
                  <img
                    className="img-thumbnail rounded-circle"
                    src={this.state.userProfilePicture.url}
                    alt="Avatar"
                    width="60"
                    height="60"
                  />
                ) : (
                  <Avatar
                    size="60"
                    round={true}
                    name={
                      this.state.userFirstname + " " + this.state.userLastname
                    }
                  />
                )}
              </div>
            </div>
            {/* Name and badges */}
            <div className="user-block-info">
              {_.has(this.state, "userFirstname") ? (
                <>
                  <span className="user-block-name">
                    {this.state.userFirstname}
                  </span>
                  {/* Role and Tier badges - Design amélioré */}
                  <div style={{ 
                    marginTop: '8px', 
                    display: 'flex', 
                    gap: '6px', 
                    flexWrap: 'wrap',
                    alignItems: 'center'
                  }}>
                    {/* User role badge - Noms dynamiques plus parlants */}
                    {this.props.userRole && (
                      <span style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '3px 10px',
                        fontSize: '11px',
                        fontWeight: '600',
                        borderRadius: '12px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        backgroundColor: 
                          this.props.userRole === 'superAdmin' ? '#dc3545' :
                          this.props.userRole === 'admin' ? '#fd7e14' :
                          this.props.userRole === 'pedagoadmin' ? '#17a2b8' :
                          this.props.userRole === 'user' ? '#6c757d' :
                          '#6c757d',
                        color: 'white',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                      }}>
                        <i className={`mr-1 ${
                          this.props.userRole === 'superAdmin' ? 'fas fa-crown' :
                          this.props.userRole === 'admin' ? 'fas fa-user-shield' :
                          this.props.userRole === 'pedagoadmin' ? 'fas fa-graduation-cap' :
                          this.props.userRole === 'user' ? 'fas fa-user' :
                          'fas fa-user'
                        }`} style={{ fontSize: '10px' }}></i>
                        {/* Noms de rôles plus parlants */}
                        {this.props.userRole === 'superAdmin' ? 'Manager+' :
                         this.props.userRole === 'admin' ? 'Manager' :
                         this.props.userRole === 'pedagoadmin' ? 'Pédago' :
                         this.props.userRole === 'user' ? this.props.t('roles.keeper') :
                         this.props.t('roles.keeper')}
                      </span>
                    )}
                    
                    {/* Zoo tier/followUpLevel badge - Design amélioré */}
                    {this.props.zooTier && (
                      <span style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        padding: '3px 10px',
                        fontSize: '11px',
                        fontWeight: '600',
                        borderRadius: '12px',
                        backgroundColor:
                          this.props.zooTier === 'research_partner' ? '#8b5cf6' :
                          this.props.zooTier === 'fullcare' ? '#10b981' :
                          this.props.zooTier === 'progress' ? '#3b82f6' :
                          this.props.zooTier === 'essential' || this.props.zooTier === 'basic' ? '#06b6d4' :
                          this.props.zooTier === 'discovery' ? '#94a3b8' :
                          this.props.zooTier === 'akongo' ? '#a855f7' :
                          '#fbbf24',
                        color: 'white',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                      }}>
                        <i className={`mr-1 ${
                          this.props.zooTier === 'research_partner' ? 'fas fa-microscope' :
                          this.props.zooTier === 'fullcare' ? 'fas fa-star' :
                          this.props.zooTier === 'progress' ? 'fas fa-chart-line' :
                          this.props.zooTier === 'essential' || this.props.zooTier === 'basic' ? 'fas fa-check-circle' :
                          this.props.zooTier === 'discovery' ? 'fas fa-compass' :
                          this.props.zooTier === 'akongo' ? 'fas fa-rocket' :
                          'fas fa-info-circle'
                        }`} style={{ fontSize: '10px' }}></i>
                        {this.props.zooTier === 'research_partner' ? 'Research' :
                         this.props.zooTier === 'fullcare' ? 'Full Care' :
                         this.props.zooTier === 'basic' ? 'Essential' :
                         this.props.zooTier === 'essential' ? 'Essential' :
                         this.props.zooTier === 'progress' ? 'Progress' :
                         this.props.zooTier === 'discovery' ? 'Discovery' :
                         this.props.zooTier === 'akongo' ? 'Akongo' :
                         this.props.zooTier.charAt(0).toUpperCase() + this.props.zooTier.slice(1)}
                      </span>
                    )}
                  </div>

                                  </>
              ) : null}
            </div>
          </div>
        </div>

        </Collapse>
    );
  }
}

SidebarUserBlock.propTypes = {
  showUserBlock: PropTypes.bool,
  theme: PropTypes.object,
};

const mapStateToProps = (state) => ({
  showUserBlock: state.settings.showUserBlock,
  theme: state.theme,
  zooTier: state.zoo.zooTier,
  userRole: state.zoo.userRole,
});

const mapDispatchToProps = (dispatch) => ({
  setZooTier: (tier) => dispatch(setZooTier(tier)),
  setUserRole: (role) => dispatch(setUserRole(role)),
  setZooTimezone: (timezone) => dispatch(setZooTimezone(timezone))
});

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translations")(SidebarUserBlock));
